<template>
  <div class="stats-container">
    <div
      v-for="positive in this.propPositive"
      :key="positive"
      class="ui list"
    >
      <a class="item">
        <i class="green check circle icon" />
        <h5 class="content">
          {{ positive }}
        </h5>
      </a>
    </div>
    <div
      v-for="danger in this.propDanger"
      :key="danger"
      class="ui list"
    >
      <a class="item">
        <i class="red warning circle icon" />
        <h5 class="content">
          {{ danger }}
        </h5>
      </a>
    </div>
    <div
      v-for="warning in this.propWarning"
      :key="warning"
      class="ui list"
    >
      <a class="item">
        <i class="yellow warning sign icon" />
        <h5 class="content">
          {{ warning }}
        </h5>
      </a>
    </div>
    <div
      v-for="alert in this.propLastAlert"
      :key="alert"
      class="ui list"
    >
      <a class="item">
        <i class="purple announcement icon" />
        <div class="content">
          {{ alert }}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stats',
  props: ['propPositive', 'propWarning', 'propDanger', 'propLastAlert'],
}

</script>

<style scoped>
.stats-container {
  height: 175px;
}
.content {
  color: black;
}
.alert {
  color: gray;
}

</style>
